import { FC, ReactNode } from 'react';
import { PRINT_SHEET_CLASS as C } from '../printStyles';

/** A blank, writable rule. `count` stacks several for a longer answer. */
export const RuledLines: FC<{ count?: number }> = ({ count = 1 }) => (
  <div className={`${C}__ruleStack`}>
    {Array.from({ length: count }, (_, index) => (
      <div key={index} className={`${C}__rule`} />
    ))}
  </div>
);

/** A rule with a caption underneath it, for time slots, Qty/Memo and the like. */
export const LabelledSlot: FC<{ label: string; grow?: number; children?: ReactNode }> = ({
  label,
  grow = 1,
  children,
}) => (
  <div className={`${C}__slot`} style={{ flex: `${grow} 1 0` }}>
    {children ?? <div className={`${C}__rule`} />}
    <span className={`${C}__fieldLabel`}>{label}</span>
  </div>
);

export const InlineFields: FC<{ children: ReactNode }> = ({ children }) => (
  <div className={`${C}__inlineFields`}>{children}</div>
);

type OptionListProps = {
  options: readonly string[];
  glyph: 'check' | 'radio';
};

/**
 * One option per line so a long option label wraps under itself rather than
 * colliding with the next one.
 */
export const OptionList: FC<OptionListProps> = ({ options, glyph }) => (
  <div>
    {options.map((option, index) => (
      <div key={`${option}-${index}`} className={`${C}__option`}>
        <span className={glyph === 'check' ? `${C}__checkGlyph` : `${C}__radioGlyph`} />
        <span className={`${C}__optionText`}>{option}</span>
      </div>
    ))}
  </div>
);
